/* save-snapshot-button.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { useAtomValue } from "jotai";
import theme from "../theme";
import { useSnapshots } from "../state/snapshots";
import { editorStateAtom } from "../state/editor-state";
var _20 = "._d0altlke:hover{cursor:pointer}";
var _19 = "._irr34135:hover{background-color:rgba(203,166,247,.8)}";
var _18 = "._19itglyw{border:none}";
var _17 = "._2rko1l7b{border-radius:3px}";
var _16 = "._ouxl1qre{background-position:50% 50%}";
var _15 = "._12veglyw{background-repeat:none}";
var _14 = "._1lrwmp9v{background-size:20px 20px}";
var _13 = "._4t3i1tcg{height:24px}";
var _12 = "._19bvi2wt{padding-left:6px}";
var _11 = "._n3tdidpf{padding-bottom:0}";
var _10 = "._u5f3i2wt{padding-right:6px}";
var _9 = "._ca0qidpf{padding-top:0}";
var _8 = "._vwz410yn{line-height:25px}";
var _7 = "._1wyb1crf{font-size:9pt}";
var _6 = "._bfhk1emw{background-color:rgba(203,166,247,.6)}";
var _5 = "._syazu67f{color:#fff}";
var _4 = "._154ismyl{top:-28px}";
var _3 = "._1xi2zwfg{right:2pc}";
var _2 = "._kqswstnw{position:absolute}";
var _ = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
var saveSnapshotButtonStyles = null;
var SaveSnapshotButton = function SaveSnapshotButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20]), /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: ax(["_r06hglyw _kqswstnw _1xi2zwfg _154ismyl _syazu67f _bfhk1emw _1wyb1crf _vwz410yn _ca0qidpf _u5f3i2wt _n3tdidpf _19bvi2wt _4t3i1tcg _1lrwmp9v _12veglyw _ouxl1qre _2rko1l7b _19itglyw _irr34135 _d0altlke"])
  }, children));
};
export default function SaveSnapshot() {
  var _useSnapshots = useSnapshots(),
    _useSnapshots2 = _slicedToArray(_useSnapshots, 2),
    snapshotsDispatch = _useSnapshots2[1];
  var editorState = useAtomValue(editorStateAtom);
  var handleClick = React.useCallback(function () {
    var snapshotName = prompt("Enter snapshot name", "" + Date.now());
    if (!snapshotName || !editorState) return;
    var snapshot = {
      name: snapshotName,
      timestamp: Date.now(),
      snapshot: editorState.doc.toJSON()
    };
    snapshotsDispatch({
      type: "save",
      payload: {
        snapshot: snapshot
      }
    });
  }, [editorState]);
  return /*#__PURE__*/React.createElement(SaveSnapshotButton, {
    onClick: handleClick
  }, "Save snapshots");
}